import InlineCheckout from './InlineCheckout';

export default InlineCheckout;
